module.exports = __webpack_public_path__ + "85b1d5fd2d34668d25590ccc56c68dd2.svg";